"use client"

import { useState } from "react"
import { IoCloudUploadOutline } from "react-icons/io5"

export default function TransactionDetails({
  transactionDate,
  transactionId,
  file,
  onDateChange,
  onIdChange,
  onFileChange,
  transactionIdMaxLength = 20,
}) {
  const handleFileUpload = (e) => {
    const selectedFile = e.target.files[0]
    if (selectedFile) {
      validateAndHandleFile(selectedFile)
    }
  }

  const handleDragOver = (e) => {
    e.preventDefault()
  }

  const handleDrop = (e) => {
    e.preventDefault()
    const selectedFile = e.dataTransfer.files[0]
    if (selectedFile) {
      validateAndHandleFile(selectedFile)
    }
  }

  const [error, setError] = useState('')

  const allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf', 'zip']

  const validateAndHandleFile = (file) => {
    if (!file || !file.name) {
      setError('Invalid file.')
      return
    }
    const parts = file.name.split('.')
    const ext = parts.length > 1 ? parts.pop().toLowerCase() : ''
    if (!allowedExtensions.includes(ext)) {
      setError('Invalid file type. Allowed: jpg, png, pdf, zip.')
      return
    }
    setError('')
    onFileChange(file)
  }

  return (
    <div className="space-y-4">
      <p className="text-sm text-red-500">Once Payment is done, upload a screenshot below as proof of payment.</p>

      <div>
        <label className="block text-sm mb-1">Transaction date *</label>
        <input
          type="date"
          value={transactionDate}
          onChange={(e) => onDateChange(e.target.value)}
          max={new Date().toISOString().split("T")[0]}  // prevents future dates
          className="w-full p-2 border rounded-md"
        />
      </div>

      <div>
        <label className="block text-sm mb-1">Transaction ID *</label>
        <input
          type="text"
          value={transactionId}
          onChange={(e) => onIdChange(e.target.value)}
          inputMode="text"
          maxLength={transactionIdMaxLength}
          className="w-full p-2 border rounded-md"
        />
      </div>

      <div>
        <label className="block text-sm mb-1">Proof of payment *</label>
        <div
          className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center cursor-pointer"
          onDragOver={handleDragOver}
          onDrop={handleDrop}
          onClick={() => document.getElementById("file-upload").click()}
        >
          <input id="file-upload" type="file" className="hidden" onChange={handleFileUpload} accept=".jpg,.jpeg,.png,.pdf,.zip" />
          <IoCloudUploadOutline className="mx-auto h-12 w-12 text-gray-400" />
          <p className="mt-2 text-sm text-gray-600">Click to upload or drag and drop</p>
          <p className="text-xs text-gray-500">(jpg, png, pdf or zip files only)</p>
          {file && <p className="mt-2 text-sm text-green-600">File selected: {file.name}</p>}
          {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
        </div>
      </div>
    </div>
  )
}

